export default {
  deleteUserResponseSuccessMsg: "Survey response deleted successfully",
  deleteUserResponseFailedMsg: "Deleting survey response failed",
  updateUserDetailsSuccess: "Users data saved successfully",
  updateUserDetailsFailed: "Failed to update users data",
  updateParticipantDetailsSuccess: "Participant data saved successfully",
  updateParticipantDetailsFailed: "Failed to update participant data",
  userAlreadyExist: "User already exists",
};
